//authconfig.js
import { LogLevel } from "@azure/msal-browser";

// Safely get the origin, handling cases where window might not be available
const getOrigin = () => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  // Fallback for SSR or build time
  return 'http://localhost:3000';
};

export const msalConfig = {
    auth: {
        clientId: "a6c3f13c-8f85-4016-8a1e-86255ff6ba14",
        authority: "https://login.microsoftonline.com/bigtappanalytics.com",
        redirectUri: getOrigin(),
        postLogoutRedirectUri: getOrigin(),
        navigateToLoginRequestUrl: false,
        clientCapabilities: ["CP1"], // Enable Conditional Access
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        allowNativeBroker: false,
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        allowRedirectInIframe: false, // Important for security
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        // Log all errors for debugging
                        console.error('[MSAL Error]:', message);
                        return;
                    case LogLevel.Warning:
                        console.warn('[MSAL Warning]:', message);
                        return;
                    case LogLevel.Info:
                        console.info('[MSAL Info]:', message);
                        return;
                    case LogLevel.Verbose:
                        console.debug('[MSAL Verbose]:', message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: LogLevel.Info, // Increased log level for better debugging
        },
    },
};

// Only log config in development
if (process.env.NODE_ENV === 'development') {
    console.log("MSAL Config initialized:", {
        clientId: msalConfig.auth.clientId,
        authority: msalConfig.auth.authority,
        redirectUri: msalConfig.auth.redirectUri,
        currentUrl: typeof window !== 'undefined' ? window.location.href : 'N/A'
    });
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
    scopes: ["User.Read", "User.ReadBasic.All", "openid", "profile", "email"],
}; 